
export const words: { [key: string]: { [key: string]: string; }} = {
 

  "showDetails" : {
    "heb":  "הצג פרטים",
    "eng": "",
    "ara":  "הצג פרטים",
  },
  "yisumaticaRepHelp": {
    "heb":  "לעזרה מנציג יישומטיקה",
    "eng": "",
    "ara": "לעזרה מנציג יישומטיקה"
  },
  "guestmode": {
    "heb": "נכנסתם במצב אורח",
    "eng": "",
    "ara": "נכנסתם במצב אורח"
  },
  "userIsNotLoggedIn" : {
    "heb": "נכנסת לאתר כאורח, על מנת לראות את כלל התכנים באתר התחבר בהזדהות אחידה או עם סיסמה.",
    "eng": "",
    "ara": "נכנסת לאתר כאורח, על מנת לראות את כלל התכנים באתר התחבר בהזדהות אחידה או עם סיסמה.",
  },
  "kita3partiacl" : {
    "heb": "כיתה ג - חלקי",
    "eng": "",
    "ara": "כיתה ג - חלקי"
  },
  "linksVideo": {
    "heb": "תוכניות לימודים - סרטון הדרכה",
    "eng": "",
    "ara": "المناهج التعليمية - فيديو ارشاد"
  },
  "tutorial": {
    "heb":  "סרטון הדרכה",
    "eng": "",
    "ara": "סרטון הדרכה"
  },
  "closeTutorial": {
    "heb":  "סגור סרטון הדרכה",
    "eng": "",
    "ara": "סגור סרטון הדרכה"
  },
  "chatWithZvi1": {
    "heb":  "רוצים להכין את שיעור היישומטיקה הראשון שלכם עכשיו?",
    "eng": "",
    "ara": "רוצים להכין את שיעור היישומטיקה הראשון שלכם עכשיו?"
  },
  "chatWithZvi2": {
    "heb":  "לחצו כאן להדרכה אישית ממוקדת עם מומחה תוכן",
    "eng": "",
    "ara": "לחצו כאן להדרכה אישית ממוקדת עם מומחה תוכן"
  },
  "yisumaticaChat": {
    "heb":  "הצטרפו לקבוצה השקטה של יישומטיקה:",
    "eng": "",
    "ara":"הצטרפו לקבוצה השקטה של יישומטיקה:",
  },
  "privacy": {
    "heb": "מדיניות פרטיות",
    "eng": "",
    "ara": "سياسة الخصوصية",
  },
  "join": {
    "heb": "להצטרפות",
    "eng": "",
    "ara": "להצטרפות",
  },
  "selfTeachVideo": {
    "heb": "עבודה עצמית - סרטון הדרכה",
    "eng": "",
    "ara": "عمل ذاتي - فيديو ارشاد",
  },
  "selfTeaching": {
    "heb": "עבודה עצמית",
    "eng": "",
    "ara": "عمل ذاتي"
  },
  "chatWithGali": {
    "heb": "שוחח עם נציג",
    "eng": "",
    "ara": "שוחח עם נציג",
  },
  "linkCopied": {
    "heb": "קישור ישיר לסרטון הועתק עבורכם",
    "eng": "",
    "ara": "קישור ישיר לסרטון הועתק עבורכם"
  },
  "userNotSubscribed": {
    "heb": "אין לך מנוי ליישומטיקה",
    "eng": "",
    "ara": "אין לך מנוי ליישומטיקה",
  },
  "emailGali": {
    "heb": "להארכת מנוי כתבו ל: gali7654@gmail.com",
    "eng": "",
    "ara": "להארכת מנוי כתבו ל: gali7654@gmail.com",
  },
  "betterCallGali": {
    "heb": "לנושאים דחופים ניתן להתקשר לגלי שמעוני: 050-8386502",
    "eng": "",
    "ara": "לנושאים דחופים ניתן להתקשר לגלי שמעוני: 050-8386502",
  },
  "lessonsVerified": {
    "heb": "כל השיעורים אושרו על ידי צוות המרכז הישראלי למצוינות בחינוך",
    "eng": "",
    "ara": "כל השיעורים אושרו על ידי צוות המרכז הישראלי למצוינות בחינוך",
  },
  "getGrade": {
    "heb": "תוכן זה זמין עבור מנויים לתכני כיתות",
    "eng": "",
    "ara": "תוכן זה זמין עבור מנויים לתכני כיתות",
  },
  "vidoeTimeOver": {
    "heb": 'אורך סרטון מקסימלי הינו 10 דקות.',
    "eng": "",
    "ara": 'אורך סרטון מקסימלי הינו 10 דקות.',
  },
  "noUserVideos": {
    "heb": 'לא נמצאו סרטונים שלך',
    "eng": "",
    "ara": 'לא נמצאו סרטונים שלך',
  },
  "confirmVideoDeletion": {
    "heb": 'לחיצה על כפתור ״מחק״ תגרום למחיקת הסרטון',
    "eng": "",
    "ara": 'לחיצה על כפתור ״מחק״ תגרום למחיקת הסרטון',
  },
  "videoSaved": {
    "heb": 'הסרטון נשמר בהצלחה',
    "eng": "",
    "ara": 'הסרטון נשמר בהצלחה',
  },
  "delete": {
    "heb": 'מחק',
    "eng": "",
    "ara": 'מחק',
  },
  "myVideos": {
    "heb": 'הסרטונים שלי',
    "eng": "",
    "ara": 'הסרטונים שלי',
  },
  "noVideoTitle": {
    "heb": 'נא להזין כותרת בתיבת הטקסט',
    "eng": "",
    "ara": 'נא להזין כותרת בתיבת הטקסט',
  },
  "duplicateVideoTitle": {
    "heb": 'סרטון בשם זה כבר קיים. אנא בחר שם אחר.',
    "eng": "",
    "ara": 'סרטון בשם זה כבר קיים. אנא בחר שם אחר.'
  },
  "enterVideoTitle": {
    "heb": `בחר כותרת לסרטון`,
    "eng": "",
    "ara": `בחר כותרת לסרטון`,
  },
  "record_new_video": {
    "heb": `הקלט סרטון חדש`,
    "eng": "",
    "ara": `הקלט סרטון חדש`,
  },  
  "recordVideo": {
    "heb": `הקלט סרטון`,
    "eng": "",
    "ara": `הקלט סרטון`,
  },
  "recording": {
    "heb": `מקליט כעת`,
    "eng": "",
    "ara": `מקליט כעת`,
  },  
  "save": {
    "heb": `שמור`,
    "eng": "",
    "ara": `שמור`,
  },  
  "successfulVideoUpload": {
    "heb": `הסרטון נשמר בהצלחה`,
    "eng": "",
    "ara": `הסרטון נשמר בהצלחה`,
  },  
  "microphonePermissionRequired": {
    "heb": `להמשך אנא אשרו לאתר יישומטיקה גישה למיקרופון`,
    "eng": "",
    "ara": `להמשך אנא אשרו לאתר יישומטיקה גישה למיקרופון`,
  },  
  "playRecordedVideo": {
    "heb": `צפה בסרטון מוקלט`,
    "eng": "",
    "ara": `צפה בסרטון מוקלט`,
  },
  "startRecording": {
    "heb": `התחל הקלטה`,
    "eng": "",
    "ara": `התחל הקלטה`,
  },
  "stopRecording": {
    "heb": `הפסק הקלטה`,
    "eng": "",
    "ara": `הפסק הקלטה`,
  },
  "showLink": {
    "heb": `פתח בחלון חדש`,
    "eng": "",
    "ara": `פתח בחלון חדש`,
  },
  "semelMosad": {
    "heb": `סמל מוסד`,
    "eng": "",
    "ara": `סמל מוסד`,
  },
  "freeAccessForAll": {
    "heb": `כל תכני אתר יישומטיקה פתוחים כעת בכניסה באמצעות המערכת של ההזדהות האחידה. מומלץ להתנתק ולהתחבר משם.`,
    "eng": "",
    "ara": `כל תכני אתר יישומטיקה פתוחים כעת בכניסה באמצעות המערכת של ההזדהות האחידה. מומלץ להתנתק ולהתחבר משם.`,
  },
  "description": {
    "heb": `תיאור`,
    "eng": "",
    "ara": `תיאור`,
  },
  "game": {
    "heb": `משחק`,
    "eng": "",
    "ara": `משחק`,
  },
  "practice": {
    "heb": `אימון`,
    "eng": "",
    "ara": `אימון`,
  },
  "whatsappRegister": {
    "heb": `להצטרפות`,
    "eng": "",
    "ara": `להצטרפות`,
  },
  "disableWhatsappReminder": {
    "heb": `לא תודה`,
    "eng": "",
    "ara": `לא תודה`,
  },
  "expirationText2": {
    "heb": `לדיווח על מצב המנוי או על רכישת מנוי – צרו קשר עם נציג יישומטיקה:`,
    "eng": "",
    "ara": `לדיווח על מצב המנוי או על רכישת מנוי – צרו קשר עם נציג יישומטיקה:`,
  },
  "expirationText1": {
    "heb": `אתר יישומטיקה פתוח כעת למנויים בלבד.`,
    "eng": "",
    "ara": `אתר יישומטיקה פתוח כעת למנויים בלבד.`,
  },
  "tutorials": {
    "heb": `סרטוני הסבר`,
    "eng": "",
    "ara": `فيديو للشرح`,
  },
  "getPlus": {
    "heb": `תוכן זה זמין לרוכשים של יישומטיקה פלוס.`,
    "eng": "Integers",
    "ara": `תוכן זה זמין לרוכשים של יישומטיקה פלוס.`,
  },
  "getPlus2": {
    "heb": `לפרטים נוספים ולרכישה כתבו אלינו:`,
    "eng": "Integers",
    "ara": `לפרטים נוספים ולרכישה כתבו אלינו:`,
  },
  "goToContent": {
    "heb": "תכנים",
    "eng": "Content",
    "ara": "محتويات"
  },
  "generalError": {
    "heb": `משהו לא בסדר. אנא נסו שוב מאוחר יותר`,
    "eng": "Integers",
    "ara": `משהו לא בסדר. אנא נסו שוב מאוחר יותר`
  },
  "messageSent": {
    "heb": `ההודעה נשלחה בהצלחה`,
    "eng": "Integers",
    "ara": `ההודעה נשלחה בהצלחה`
  },
  "nameRequired": {
    "heb": `אנא הזן את שם השולח`,
    "eng": "Integers",
    "ara": `אנא הזן את שם השולח`
  },
  "messageRequired": {
    "heb": `אנא הזן הודעה`,
    "eng": "Integers",
    "ara": `אנא הזן הודעה`
  },
  "sendMessage": {
    "heb": `שלח`,
    "eng": "Integers",
    "ara": `שלח`
  },
  "name": {
    "heb": `שם`,
    "eng": "Integers",
    "ara": `שם`
  },
  "message": {
    "heb": `הודעה`,
    "eng": "Integers",
    "ara": `הודעה`
  },
  "taskPage": {
    "heb": `דפי משימה`,
    "eng": "",
    "ara": `مهمه`
  },
  "subscriberContent": {
    "heb": `מנויים בלבד`,
    "eng": "Integers",
    "ara": `מנויים בלבד`
  },
  "register": {
    "heb": `הירשם`,
    "eng": "Integers",
    "ara": `הירשם`
  },
  "registerError": {
    "heb": `אנא הזן כתובת דוא״ל תקינה`,
    "eng": "Integers",
    "ara": `אנא הזן כתובת דוא״ל תקינה`
  },
  "remindMeNextWeek": {
    "heb": `הזכר לי בשבוע הבא`,
    "eng": "Integers",
    "ara": `הזכר לי בשבוע הבא`
  },
  "registerEmail": {
    "heb": `הצטרפו לקבוצת ווטסאפ שקטה להודעות על חידושים והדרכות באתר`,
    "eng": "Integers",
    "ara": `הצטרפו לקבוצת ווטסאפ שקטה להודעות על חידושים והדרכות באתר`
  },
  "emailAddress": {
    "heb": `כתובת דוא״ל`,
    "eng": "Integers",
    "ara": `כתובת דוא״ל`
  },
  "studentPages" : {
    "heb": `דפי תלמיד`,
    "eng": "Integers",
    "ara": `דפי תלמיד`
  },
  "teacherPages" : {
    "heb": `דפי מורה`,
    "eng": "Integers",
    "ara": `דפי מורה`
  },
  "enrichmentPages" : {
    "heb": `דפי הרחבה`,
    "eng": "Integers",
    "ara": `דפי הרחבה`
  },
  "emptyLessonsResult" : {
    "heb": `לא נמצאו שיעורים שלך`,
    "eng": "Integers",
    "ara": `لا يوجد دروس لك`
  },
  "emptyFavoritesResult" : {
    "heb": `לא נמצאו מועדפים בקטגוריה שבחרת`,
    "eng": "Integers",
    "ara": `لا يوجد فىة مفضلة مختارة `
  },
  "emptyGradeResult" : {
    "heb": `לא נמצאו תכנים בקטגוריה שבחרת עבור כיתה`,
    "eng": "Integers",
    "ara": `لا يوجد محتوى كفىة  مختارة للصف`
  },
  "emptySearchResult" : {
    "heb": `לא נמצאו תכנים הכוללים את מילות החיפוש:`,
    "eng": "Integers",
    "ara": `لا يوجد محتوى يضم كلمات البحث`
  },
  "emptyGroup" : {
    "heb": "לא נמצאו תכנים בקבוצה",
    "eng": "Integers",
    "ara": "لا يوجد محتوى بالمجموعة",
  },
  "fatherApp": {
    "heb": " יישומון האב",
    "eng": "Integers",
    "ara": " للتطبيق الأصل"
  },
  "myLessons": {
    "heb": "השיעורים שלי",
    "eng": "Integers",
    "ara": "دروسي الخاصة"
  },
  "myContent": {
    "heb": "השיעורים שלי",
    "eng": "Integers",
    "ara": "دروسي الخاصة"
  },
  "continueToApp": {
    "heb": "ליישומון",
    "eng": "Integers",
    "ara": "للتَّطبيق"
  },
  "continueToLesson": {
    "heb": "לשיעור",
    "eng": "Integers",
    "ara": "للدّرس"
  },
  "loginAsUserNotGuest": {
    "heb": "כנס כמשתמש ולא כאורח",
    "eng": "Login as user, not as guest",
    "ara": "تسجيل الدخول كمستخدم وليس كضيف"
  },
  "groupLessons": {
    "heb": "שיעורי הקבוצה",
    "eng": "Integers",
    "ara": "دروس المجموعه"
  },
  "groupLessonsLink": {
    "heb": "קישור ישיר לשיעורי הקבוצה",
    "eng": "Integers",
    "ara": "رابط خاص لدرس المجموعه"
  },
  "groups": {
    "heb": "קבוצות",
    "eng": "Integers",
    "ara": "المجموعات"
  },
  "appDescription": {
    "heb": "תאור היישומון",
    "eng": "Integers",
    "ara": "وصف التطبيق"
  },
  "updating": {
    "heb": "מעדכן",
    "eng": "Integers",
    "ara": "تحديث"
  },
  "getLostGuest": {
  //  "heb": "לאורחים אין גישה לתכני המורים",
    "heb": "תוכן זה נגיש למנויים בלבד",
    "eng": "Integers",
   // "ara": "للزائرين لا يوجد  امكانية للوصول الى محتويات المعلمين "
    "ara":  "תוכן זה נגיש למנויים בלבד"
  },
  "guestAppsNotAvailable": {
    "heb": "היישומונים אינם פתוחים בכניסת אורח",
    "eng": "Applets are not available in guest mode",
    "ara": "التطبيقات غير متاحة في وضع الضيف"
  },
  "confirmSignOut": {
    "heb": "התנתק מיישומטיקה?",
    "eng": "Integers",
    "ara": "تسجيل الخروج من يوسمتيكا"
  },
  "teacherUrlModalTitle": {
    "heb": "קישור ייחודי הועתק עבורכם. הדביקו אותו (CTRL V) במייל, בווטסאפ, בצ'אט של הזום וכו', שילחו אותו לתלמידיכם ותוכלו לראות את תוצאותיהם. הקישור פעיל לשבועיים",
    "eng": "",
    "ara": "تم نسخ الرابط الخاص بكم. الصقه ( ctrl v) بالبريد الالكتروني،بالواتس اب، رسائل الزوم||ارساله للطلاب ويمكنكم مشاهدة نتائجهم. الرابط يعمل لاسبوعين"
  },
  "groupUrlModalTitle1": {
    "heb": "הקישור הועתק. ניתן להדביק אותו (CTRL V) במייל, בווטסאפ וכו׳ ולשלוח לתלמידים. קישור זה יפתח מייד את המסך הזה עם השיעורים של קבוצה זו.",
    "eng": "Integers",
    "ara": "הקישור הועתק. ניתן להדביק אותו (CTRL V) במייל, בווטסאפ וכו׳ ולשלוח לתלמידים. קישור זה יפתח מייד את המסך הזה עם השיעורים של קבוצה זו."
  },
  "showResults": {
    "heb": "התלמיד יראה ציון של X או V על התשובות לאחר ההגשה",
    "eng": "Integers",
    "ara": "الطالب يرى إشارة V او إشارة X على الإجابات بعد التسليم"
  },
  "showScore": {
    "heb": "התלמיד יראה את הציון שלו בעת הגשת המבדק (אם הציון מעל 70)",
    "eng": "Integers",
    "ara": "الطالب يشاهد علامتة عندما يسلم الاختبار( بشرط اذا كان العلامة اعلى من 70) "
  },
  "createUrl": {
    "heb": "צור קישור",
    "eng": "",
    "ara": "اضف الرابط"
  },
  "createUrlMivdak": {
    "heb": "צור קישור לעבודה עצמית",
    "eng": "",
    "ara": "اضف الرابط"
  },
  "guest": {
    "heb": "אורח",
    "eng": "Integers",
    "ara": "زائر"
  },
  "viewScores": {
    "heb": "נתוני התלמידים",
    "eng": "Integers",
    "ara": "معطيات التلاميذ"
  },
  "שלמים": {
    "heb": "שלמים",
    "eng": "Integers",
    "ara": "أعداد صحيحة"
  },
  "גיאומטרייה": {
    "heb": "גיאומטרייה",
    "eng": "Geometry",
    "ara": "هندسة"
  },
  "שבר": {
    "heb": "שבר",
    "eng": "Fractions",
    "ara": "كسر"
  },
  "נושאים נוספים": {
    "heb": "נושאים נוספים",
    "eng": "Additional Topics",
    "ara": "مواضيع أخرى"
  },
  "ציר": {
    "heb": "ציר",
    "eng": "Axes",
    "ara": "محور"
  },
  "גרפים": {
    "heb": "גרפים",
    "eng": "Graphs",
    "ara": "بحث معطيات"
  },
  "אלגברה": {
    "heb": "אלגברה",
    "eng": "Algebra",
    "ara": "الجبر"
  },
  "הסתברות": {
    "heb": "הסתברות",
    "eng": "Probability",
    "ara": "الاحتمال"
  },
  "אחר": {
    "heb": "אחר",
    "eng": "Other",
    "ara": "آخر"
  },
  "מספרים עשרוניים": {
    "heb": "מספרים עשרוניים",
    "eng": "Decimals",
    "ara": "أعداد عشرية"
  },
  "חיפוש": {
    "heb": "חיפוש",
    "eng": "Search",
    "ara": "חיפוש"
  },
  "כיתות": {
    "heb": "כיתות",
    "eng": "Grades",
    "ara": "الصفوف"
  },
  "המבנה העשרוני": {
    "heb": "המבנה העשרוני",
    "eng": "Decimal System",
    "ara": "المبنى العشري"
  },
  "חוק הפילוג": {
    "heb": "חוק הפילוג",
    "eng": "Distribution Law",
    "ara": "قانون التوزيع"
  },
  "פעולות חשבון במאונך": {
    "heb": "פעולות חשבון במאונך",
    "eng": "Vertical Arithmetic",
    "ara": "العمليات الحسابية عاموديا"
  },
  "תרגולים בפעולות החשבון": {
    "heb": "תרגולים בפעולות החשבון",
    "eng": "Arithmetic Challenges",
    "ara": "تدريب على العمليات الحسابية"
  },
  "אחוזים": {
    "heb": "אחוזים",
    "eng": "Percentages",
    "ara": "نسبة مئوية"
  },
  "חילוק בשלמים": {
    "heb": "חילוק בשלמים",
    "eng": "Integer Division",
    "ara": "القسمة على صحيح"
  },
  "מגוון נושאים במספרים שלמים": {
    "heb": "מגוון נושאים במספרים שלמים",
    "eng": "Various Integer Challenges",
    "ara": "مواضيع متنوّعة بالأعداد الصحيحة"
  },
  "שברים במודלים שונים": {
    "heb": "שברים במודלים שונים",
    "eng": "Fractions In Various Models",
    "ara": "كسور بنماذج مختلفة"
  },
  "פעולות חשבון בשברים": {
    "heb": "פעולות חשבון בשברים",
    "eng": "Arithmetic With Fractions",
    "ara": "عمليات حسابية على الكسور"
  },
  "משחקים בשברים": {
    "heb": "משחקים בשברים",
    "eng": "Fraction Games",
    "ara": "ألعاب في الكسور"
  },
  "games": {
    "heb": "משחקים",
    "eng": "משחקים",
    "ara": "משחקים"
  },
  "נושאים נוספים בשברים": {
    "heb": "נושאים נוספים בשברים",
    "eng": "Various Fraction Challenges",
    "ara": "مواضيع أخرى في الكسور"
  },
  "קנה מידה": {
    "heb": "קנה מידה",
    "eng": "Scale",
    "ara": "مقياس"
  },
  "תכונות מרובעים": {
    "heb": "תכונות מרובעים",
    "eng": "Quadrilateral Attributes",
    "ara": "صفات الأشكال الرباعية"
  },
  "תלת ממד": {
    "heb": "תלת ממד",
    "eng": "3D",
    "ara": "ثلاثي الأبعاد"
  },
  "זוויות": {
    "heb": "זוויות",
    "eng": "Angles",
    "ara": "زوايا"
  },
  "היקפים": {
    "heb": "היקפים",
    "eng": "Perimeters",
    "ara": "محيطات"
  },
  "שטח משולש": {
    "heb": "שטח משולש",
    "eng": "Triangle Area",
    "ara": "مساحة المثلث"
  },
  "מעגל": {
    "heb": "מעגל",
    "eng": "Circles",
    "ara": "دائرة"
  },
  "יישומונים כלליים לאיורים גיאומטריים": {
    "heb": "יישומונים כלליים לאיורים גיאומטריים",
    "eng": "Geometric Illustration Apps",
    "ara": "تطبيقات عامّة لأشكال هندسيّة"
  },
  "זיהוי צורות מוסתרות": {
    "heb": "זיהוי צורות מוסתרות",
    "eng": "Identifying Hidden Shapes",
    "ara": "تحديد أشكال مخفيّة"
  },
  "מגוון נושאים בגיאומטרייה": {
    "heb": "מגוון נושאים בגיאומטרייה",
    "eng": "Various Geometry Challenges",
    "ara": "مواضيع متنوّعة في الهندسة"
  },
  "mivdakDescription": {
    "heb": "תאור המבדק",
    "eng": "favorites",
    "ara": "وصف الاختبار"
  },
  "favorites": {
    "heb": "מועדפים",
    "eng": "favorites",
    "ara": "مُفضّلة"
  },
  "teacherLesson": {
    "heb": "שיעור",
    "eng": "lessons",
    "ara": "درس المعلمين "
  },
  "mivdak": {
   // "heb": "מבדק",
    "heb": "עבודה עצמית",
    "eng": "lessons",
    "ara": "اختبار"
  },
  "lessonDescription": {
    "heb": "תאור השיעור",
    "eng": "lessons",
    "ara": "وصف الدرس"
  },
  "viewVideo": {
    "heb": "סרטון ועוד",
    "eng": "lessons",
    "ara": "فيديو والمزيد "
  },
  "allTeacherContent": {
    "heb": "כל תכני המורים",
    "eng": "lessons",
    "ara": "كل محتويات المعلمين"
  },
  "mivdakim": {
    "heb": "עבודה עצמאית",
   // "heb": "מבדקים",
    "eng": "lessons",
    "ara": "اختبارات"
  },
  "teacherLessons": {
    "heb": "שיעורים",
    "eng": "lessons",
    "ara": "دروس المعلمين"
  },
  "lesson": {
    "heb": "שיעור",
    "eng": "lessons",
    "ara": "درس"
  },
  "bigContentArr": {
   // "heb": "כל התכנים",
    "heb": "יישומונים ושיעורים",
    "eng": "content",
    "ara": "كل المحتويات"
  },
  "puzzles": {
    "heb": "פאזלים",
    "eng": "content",
    "ara": "بازل"
  },
  "puzzle": {
    "heb": "פאזל",
    "eng": "content",
    "ara": "بازل"
  },
  "shapePuzzles": {
    "heb": "פאזל הנחת הצורה",
    "eng": "content",
    "ara": "وضعية شكل البازل "
  },
  "interaction": {
    "heb": "שיעורים מיוחדים",
    "eng": "content",
    "ara": "دروس خاصة"
  },
  "interact": {
    "heb": "שיעור מיוחד",
    "eng": "content",
    "ara": "درس خاص"
  },
  "apps": {
    "heb": "יישומונים",
    "eng": "content",
    "ara": "التطبيقات"
  },
  "app": {
    "heb": "יישומון",
    "eng": "content",
    "ara": "تطبيق"
  },
  "lessons": {
    "heb": "שיעורים",
    "eng": "content",
    "ara": "دروس"
  },
  "Integers": {
    "heb": "שלמים",
    "eng": "Integers",
    "ara": "أعداد صحيحة"
  },
  "Geometry": {
    "heb": "גיאומטרייה",
    "eng": "Geometry",
    "ara": "هندسة"
  },
  "Fractions": {
    "heb": "שבר",
    "eng": "Fractions",
    "ara": "كسر"
  },
  "Additional Topics": {
    "heb": "נושאים נוספים",
    "eng": "Additional Topics",
    "ara": "مواضيع أخرى"
  },
  "content": {
    "heb": "תכנים",
    "eng": "Content",
    "ara": "محتويات"
  },
  "teacherContent": {
    "heb": "תכני מורים",
    "eng": "Teacher Content",
    "ara": "محتوى المعلم"
  },
  "Decimals": {
    "heb": "מספרים עשרוניים",
    "eng": "Decimals",
    "ara": "أعداد عشرية"
  },
  "Search": {
    "heb": "חיפוש",
    "eng": "Search",
    "ara": "بحث"
  },
  "Grades": {
    "heb": "כיתות",
    "eng": "Grades",
    "ara": "الصفوف"
  },
  "Decimal System": {
    "heb": "המבנה העשרוני",
    "eng": "Decimal System",
    "ara": "المبنى العشري"
  },
  "Distribution Law": {
    "heb": "חוק הפילוג",
    "eng": "Distribution Law",
    "ara": "قانون التوزيع"
  },
  "Vertical Arithmetic": {
    "heb": "פעולות חשבון במאונך",
    "eng": "Vertical Arithmetic",
    "ara": "العمليات الحسابية عاموديا"
  },
  "Arithmetic Challenges": {
    "heb": "תרגולים בפעולות החשבון",
    "eng": "Arithmetic Challenges",
    "ara": "تدريب على العمليات الحسابية"
  },
  "Percentages": {
    "heb": "אחוזים",
    "eng": "Percentages",
    "ara": "نسبة مئوية"
  },
  "Integer Division": {
    "heb": "חילוק בשלמים",
    "eng": "Integer Division",
    "ara": "القسمة على صحيح"
  },
  "Various Integer Challenges": {
    "heb": "מגוון נושאים במספרים שלמים",
    "eng": "Various Integer Challenges",
    "ara": "مواضيع متنوّعة بالأعداد الصحيحة"
  },
  "Fractions In Various Models": {
    "heb": "שברים במודלים שונים",
    "eng": "Fractions In Various Models",
    "ara": "كسور بنماذج مختلفة"
  },
  "Arithmetic With Fractions": {
    "heb": "פעולות חשבון בשברים",
    "eng": "Arithmetic With Fractions",
    "ara": "عمليات حسابية على الكسور"
  },
  "Fraction Games": {
    "heb": "משחקים בשברים",
    "eng": "Fraction Games",
    "ara": "ألعاب في الكسور"
  },
  "Various Fraction Challenges": {
    "heb": "נושאים נוספים בשברים",
    "eng": "Various Fraction Challenges",
    "ara": "مواضيع أخرى في الكسور"
  },
  "Scale": {
    "heb": "קנה מידה",
    "eng": "Scale",
    "ara": "مقياس"
  },
  "Quadrilateral Attributes": {
    "heb": "תכונות מרובעים",
    "eng": "Quadrilateral Attributes",
    "ara": "صفات الأشكال الرباعية"
  },
  "3D": {
    "heb": "תלת ממד",
    "eng": "3D",
    "ara": "ثلاثي الأبعاد"
  },
  "Angles": {
    "heb": "זוויות",
    "eng": "Angles",
    "ara": "زوايا"
  },
  "Perimeters": {
    "heb": "היקפים",
    "eng": "Perimeters",
    "ara": "محيطات"
  },
  "Triangle Area": {
    "heb": "שטח משולש",
    "eng": "Triangle Area",
    "ara": "مساحة المثلث"
  },
  "Circles": {
    "heb": "מעגל",
    "eng": "Circles",
    "ara": "دائرة"
  },
  "Geometric Illustration Apps": {
    "heb": "יישומונים כלליים לאיורים גיאומטריים",
    "eng": "Geometric Illustration Apps",
    "ara": "تطبيقات عامّة لأشكال هندسيّة"
  },
  "Identifying Hidden Shapes": {
    "heb": "זיהוי צורות מוסתרות",
    "eng": "Identifying Hidden Shapes",
    "ara": "تحديد أشكال مخفيّة"
  },
  "Various Geometry Challenges": {
    "heb": "מגוון נושאים בגיאומטרייה",
    "eng": "Various Geometry Challenges",
    "ara": "مواضيع متنوّعة في الهندسة"
  },
  "Axes": {
    "heb": "ציר",
    "eng": "Axes",
    "ara": "محور"
  },
  "Graphs": {
    "heb": "גרפים",
    "eng": "Graphs",
    "ara": "بحث معطيات"
  },
  "Algebra": {
    "heb": "אלגברה",
    "eng": "Algebra",
    "ara": "الجبر"
  },
  "Probability": {
    "heb": "הסתברות",
    "eng": "Probability",
    "ara": "الاحتمال"
  },
  "Other": {
    "heb": "אחר",
    "eng": "Other",
    "ara": "آخر"
  },
  "pisa_questions": {
    "heb": "שאלות ברוח פיזה",
    "eng": "",
    "ara": "تَمارِين بيزا PISA "
  },
  "classes": {
    "heb": "פרקי רענון",
    "eng": "",
    "ara": "فصول تحديثية"
  },
  "enterTeacherCode": {
    "heb": "הזן קוד מורה",
    "eng": "",
    "ara": "ادخل رمز المعلم"
  },
  "changeTeacherCode": {
    "heb": "שנה קוד מורה",
    "eng": "",
    "ara": "تغير رمز المعلم"
  },
  "teacherCode": {
    "heb": "קוד מורה",
    "eng": "",
    "ara": "رمز المعلم"
  },
  "myTeacherCode": {
    "heb": "קוד המורה שלך הוא",
    "eng": "",
    "ara": "رمز معلمك الخاص هو"
  },
  "grades": {
    "heb": "כיתות",
    "eng": "Grades",
    "ara": "الصفوف"
  },
  "ok": {
    "heb": "אישור",
    "eng": "",
    "ara": "موافق"
  },
  "emptyCode": {
    "heb": "חובה להזין קוד",
    "eng": "",
    "ara": "ملزم  بادخال الرمز"
  },
  // "studentResults": {
  //   "heb": "תשובות תלמידים",
  //   "eng": "",
  //   "ara": "إجابات التلاميذ"
  // },
  "showScores": {
    "heb": "תשובות תלמידים",
    "eng": "",
    "ara": "إجابات التلاميذ"
  },
  "frequentUse": {
    "heb": "בשימוש גבוה",
    "eng": "",
    "ara": "בשימוש גבוה",
  },
  "submissionNum": {
    "heb": "מספר המגישים",
    "eng": "",
    "ara": "عدد المرسلين"
  },
  "showStudentInfo": {
    "heb": "הצגת נתוני תלמידים",
    "eng": "",
    "ara": "عرض نتائج الطلاب"
  },
  "signOut": {
    "heb": "התנתק",
    "eng": "",
    "ara": "تسجيل خروج"
  },
  "inputIsNaN": {
    "heb": "חובה להזין ספרות בלבד",
    "eng": "",
    "ara": "ملزم  بكتابة ارقام لوحدها"
  },
  "loading": {
    "heb": "אנא המתן",
    "eng": "",
    "ara": "انتظار"
  },
  "signIn": {
    "heb": "התחברו ליישומטיקה כדי להמשיך",
    "eng": "",
    "ara": "اضغط للاتصال"
  },
  "signIn2": {
    "heb": "התחברו ליישומטיקה",
    "eng": "",
    "ara": "اضغط للاتصال"
  },
  "joinLesson": {
    "heb": "הצטרפו לשיעור",
    "eng": "",
    "ara": "الانضمام الى الدرس",
  },
  "enterLessonNum": {
    "heb": "קוד מורה",
    "eng": "",
    "ara": "קוד מורה",
  },
  "onlyNumbersAlowd" : {
    "heb": "חובה להזין ספרות בלבד",
    "eng": "",
    "ara": "חובה להזין ספרות בלבד", 
  },
  "numberCantBeEmpty" : {
    "heb": "חובה להזין מספר",
    "eng": "",
    "ara": "חובה להזין מספר", 
  },
  "showFollowLink": {
    "heb": "קישור להצטרפות לשיעור:",
    "eng": "",
    "ara": "קישור להצטרפות לשיעור:",
  },
  "followLinkNotFound": {
    "heb": "מספר השיעור לא נמצא. נסו שוב",
    "eng": "",
    "ara": "מספר השיעור לא נמצא. נסו שוב",
  },
  "links_to_programs": {
    "heb": "קישורים לתכנים לפי תכנית לימודים",
    "eng": "",
    "ara": "קישורים לתכנים לפי תכנית לימודים"
  },
  "links" :{
    "heb": "תוכניות לימודים",
    "eng": "",
    "ara": "المناهج التعليمية"
  },
  "new": {
      "heb": "חדש",
      "eng": "",
      "ara": "חדש"
  },
  "kita1": {
    "heb": "כיתה א",
    "eng": "",
    "ara": "כיתה א"
  },
  "kita2": {
    "heb": "כיתה ב",
    "eng": "",
    "ara": "כיתה ב"
  },
  "kita3": {
    "heb": "כיתה ג",
    "eng": "",
    "ara": "כיתה ג"
  },
  "kita4": {
    "heb": "כיתה ד",
    "eng": "",
    "ara": "כיתה ד"
  },
  "kita5": {
    "heb": "כיתה ה",
    "eng": "",
    "ara": "כיתה ה"
  },
  "kita6": {
    "heb": "כיתה ו",
    "eng": "",
    "ara": "כיתה ו"
  },
  "kita7": {
    "heb": "כיתה ז",
    "eng": "",
    "ara": "כיתה ז"
  },
  "continue": {
    "heb": "המשך",
    "eng": "",
    "ara": "استمر"
  },
  "return": {
    "heb": "חזור",
    "eng": "",
    "ara": "ارجع"
  },
  "close": {
    "heb": "סגור",
    "eng": "",
    "ara": "סגור"
  },
  "contact us": {
    "heb": "צור קשר",
    "eng": "",
    "ara": "توتصا معنا"
  },
  "toFatherapp": {
    "heb": "ליישומון האב",
    "eng": "",
    "ara": "للتطبيق الأصل"
  },
  "toLessons": {
    "heb": "לשיעורים",
    "eng": "",
    "ara": "للدروس"
  },
  "about": {
    "heb": "צור קשר",
    "eng": "",
    "ara": "اتصل بنا"
  },
  "aboutUs": {
    "heb": "אודות",
    "eng": "",
    "ara": "حَول"
  },
  "greeting": {
    "heb": "ברוך שובך ליישומטיקה",
    "eng": "",
    "ara": "أهلاً برجوعك لموقع يِسوماتيكا"
  },
  "greetingGuest": {
    "heb": "ברוך הבא ליישומטיקה",
    "eng": "",
    "ara": "أهلاً برجوعك لموقع يِسوماتيكا"
  },
  "greetingPlus": {
    "heb": "ברוך שובך ליישומטיקה פלוס",
    "eng": "",
    "ara": "أهلاً برجوعك لموقع يِسوماتيكا"
  },
  "allGrades": {
    "heb": "כל הכיתות",
    "eng": "",
    "ara": "جميع الصفوف"
  },
  "grade1": {
    "heb": "א",
    "eng": "",
    "ara": "الأول"
  },
  "grade2": {
    "heb": "ב",
    "eng": "",
    "ara": "الثّاني"
  },
  "grade3": {
    "heb": "ג",
    "eng": "",
    "ara": "الثّالث"
  },
  "grade4": {
    "heb": "ד",
    "eng": "",
    "ara": "الرّابع"
  },
  "grade5": {
    "heb": "ה",
    "eng": "",
    "ara": "الخامس"
  },
  "grade6": {
    "heb": "ו",
    "eng": "",
    "ara": "السّادس"
  },
  "grade7": {
    "heb": "ז",
    "eng": "",
    "ara": "السّابع"
  },
  "gali": {
    "heb": "גלי שמעוני",
    "eng": "",
    "ara": "جالي شمعوني"
  },
  "zvi": {
    "heb": "צבי שלם",
    "eng": "",
    "ara": "تسفي شلم"
  },
  "galiTitle": {
    "heb": "ראש תחום מתמטיקה",
    "eng": "",
    "ara": 'رئيس قسم الرياضيات'
  },
  "zviTitle": {
    "heb": "מפתח פדגוגי וטכנולוגי",
    "eng": "",
    "ara": "مفتاح تربوي وتكنولوجي"
  },
  "lessonsWarning": {
    "heb": "השיעורים כאן באחריות המורים שהעלו אותם",
    "eng": "",
    "ara": "الدروس هنا بمسؤولية المعلمين الذين رفعوا دروسهم للموقع"
  }
}
